import React from 'react';
import { Link } from 'react-router-dom';
import { StyledValue, StyledHeaderValues } from './HeaderValues.styles';
/**
 * Found on item detail pages. Generates a styled list of ids and/or links
 * related to the current item.
 */
export function HeaderValues(props) {
    const { values, links, className, id } = props;
    return (React.createElement(StyledHeaderValues, { className: className, "data-cy": props['data-cy'], id: id }, values === null || values === void 0 ? void 0 :
        values.map((value) => (React.createElement(StyledValue, { key: `${value.text}-${value.value}`, "data-cy": value['data-cy'] },
            React.createElement("span", { className: "header-text" },
                value.text,
                ": "),
            React.createElement("span", { className: "header-value" },
                " ",
                value.value)))), links === null || links === void 0 ? void 0 :
        links.map((link) => (React.createElement("li", { key: `${link.text}-${link.to}`, "data-cy": link['data-cy'] }, !link.isDisabled ? React.createElement(Link, { to: link.to }, link.text) : React.createElement("span", null, link.text))))));
}
//# sourceMappingURL=HeaderValues.js.map